import React from "react";
import {Dialog} from "src/components/dialogs/Dialog"
import { css } from "aphrodite-jss";
import { styles } from "src/components/dialogs/PublicationSourceDialogStyle";
import { HorizontalBarChart} from "src/components/charts/HorizontalBarChart";
import { ChartItem } from "src/models/ChartItem";
import { appStore } from "src/mobx/AppStore";
import { RequestState } from "src/models/RequestState";

interface IExpenditureDepartmentDialogProps {
    isOpen: boolean;
    onClose: any;
}

export class ExpenditureDepartmentDialog extends React.Component<IExpenditureDepartmentDialogProps> {
    
    public static defaultProps = {
        isOpen: false,
        onClose: ()=>{},
    };

    public render() {
        let content;
        if(!this.props.isOpen){
            content = (
                <div>
                    
                </div>
            );
        }else{

            const expenditureData = appStore.facultyPageStore.authorPageData.expenditureData;
        
            const departmentTitle = "Expenditure by Department";
            const departmentToolTip = "For top 10 cited since 2008 (as reported on scopus.com)";
            
            content = (
                <HorizontalBarChart id="subject_area"
                    state={expenditureData.expeditures_by_department.requestState}
                    data={expenditureData.expeditures_by_department.data}
                    error={expenditureData.expeditures_by_department.error}
                    title={departmentTitle}
                    tooltip={departmentToolTip}
                    labelName={"Department"}
                    valueLabel={"Amount"}
                    valueFormatter={this.formatValues}
                    tickCutOff={40}
                    yAxisWidth={200}
                    /> 
            )

        }               

        return (
            <Dialog isOpen={this.props.isOpen} onClose={this.props.onClose} > 
                <div id="container" className={css(styles.container)}>
                    <React.Fragment>
                        {content}
                    </React.Fragment>
                </div>
            </Dialog>
        );
    }

    public formatValues = (value: string) => {
        return "$"+value;
    }
    
}


// WEBPACK FOOTER //
// ./src/components/dialogs/ExpenditureDepartmentDialog.tsx